import RouteDesigner from "@/router/RouteDesigner"
import Authentication from "@/middleware/Authentication"
import Authorization from "@/middleware/Authorization"
import ForceTypes from "@/middleware/ForceTypes"
//import Subscribed from "@/middleware/Subscribed"

RouteDesigner.setNotFound("Error404Page", { layout: "Empty" })

export const ROUTES = {
  LOGIN: "login",
  SET_PASSWORD: "set-password",
  FORGOT_PASSWORD: "forgot-password",
  REGISTER: "register",
  PROFILE: "profile",
  SUBSCRIPTION: "subscription",
  MANAGE_SUBSCRIPTION: "manage-subscription",
  CONTACT_US: "contact-us",
  PRIVACY_POLICY: "privacy-policy",
  TERMS: "terms",
  COMPANY_PROFILE: "company-profile",
  WELDER_PROFILE: "welder-profile",

  HOME: "home",
  FIND_TALENT: "find-talent",
  FIND_WORK: "find-work",
  JOB_LISTING: "job-listing",

  COMPANY_DASHBOARD: "company-dashboard",

  JOB_LISTINGS: "job-listings",
  USERS: "users",
  USER_UPSERT: "user-upsert",
  REVIEWS: "reviews",
  TRANSACTIONS: "transactions",
}

RouteDesigner.group({ middleware: [ForceTypes, Authentication/*, Subscribed*/] }, function() {
  RouteDesigner.group({ layout: "Default" }, function() {
    RouteDesigner.route("/", "HomePage", ROUTES.HOME)
    RouteDesigner.route("/find-talent", "FindTalentPage", ROUTES.FIND_TALENT)
    RouteDesigner.route("/find-work", "FindWorkPage", ROUTES.FIND_WORK)
    RouteDesigner.route("/find-work/:id", "JobListingPage", ROUTES.JOB_LISTING).passProps()


    RouteDesigner.route("/login", "LoginPage", ROUTES.LOGIN)
    RouteDesigner.route('/forgot-password', 'ForgotPasswordPage', ROUTES.FORGOT_PASSWORD)
    RouteDesigner.route('set-password/:token', 'SetPasswordPage', ROUTES.SET_PASSWORD).passProps()
    RouteDesigner.route('/register', 'RegisterPage', ROUTES.REGISTER)
    RouteDesigner.route('/contact-us', 'ContactUsPage', ROUTES.CONTACT_US)
    RouteDesigner.route('/privacy-policy', 'PrivacyPolicyPage', ROUTES.PRIVACY_POLICY)
    RouteDesigner.route('/terms', 'TermsPage', ROUTES.TERMS)

    RouteDesigner.route("/company-profile/:id", "CompanyProfilePage", ROUTES.COMPANY_PROFILE).passProps()
    RouteDesigner.route("/welder-profile/:id", "WelderProfilePage", ROUTES.WELDER_PROFILE).passProps()
  })

  RouteDesigner.group({ middleware: [Authorization], layout: "Default" }, function() {
    RouteDesigner.route("/profile", "ProfilePage", ROUTES.PROFILE)
    //RouteDesigner.route('/subscribe', "SubscriptionPage", ROUTES.SUBSCRIPTION)
    //RouteDesigner.route('/manage-subscription', "ManageSubscriptionPage", ROUTES.MANAGE_SUBSCRIPTION)

    RouteDesigner.group({ prefix: 'company', type: 'Company' }, function () {
      RouteDesigner.route("/dashboard", "CompanyDashboardPage", ROUTES.COMPANY_DASHBOARD)
    })

    RouteDesigner.group({ prefix: 'admin', type: 'Admin' }, function () {
      RouteDesigner.group({ prefix: '/users' }, function() {
        RouteDesigner.route('', 'UsersPage', ROUTES.USERS)
        RouteDesigner.route('/details/:id?', 'UserUpsertPage', ROUTES.USER_UPSERT).passProps()
      })
      RouteDesigner.route("/job-listings", "JobListingsPage", ROUTES.JOB_LISTINGS)
      RouteDesigner.route("/reviews", "ReviewsPage", ROUTES.REVIEWS)
      RouteDesigner.route("/transactions", "TransactionsPage", ROUTES.TRANSACTIONS)
    })
  })
})
